import { useParams } from 'react-router-dom';
import useMessagingPage from '../../../../../hooks/useMessagingPage';
import MessageCard from '../../../messageCard';
import './index.css';

/**
 * ChatProps interface defines the props for the GameChatPage component.
 *
 * @hideHeader - Optional boolean to hide the header.
 */
interface ChatProps {
  hideHeader?: boolean;
}

/**
 * GameChatPage is a React functional component that renders a chat interface for a game.
 *
 * @param props - Props for the GameChatPage component.
 * @returns A React functional component representing the game chat page.
 */
const GameChatPage = (props: ChatProps) => {
  const { gameID } = useParams(); // from route like /games/:gameID/chat
  const { messages, newMessage, setNewMessage, handleSendMessage, error } = useMessagingPage(
    'game',
    gameID,
  );

  return (
    <div className='game-chat-room'>
      <div className='chat-messages'>
        {messages.map(message => (
          <MessageCard key={String(message._id)} message={message} />
        ))}
      </div>
      <div className='message-input'>
        <textarea
          className='message-textbox'
          placeholder='Type your message here'
          value={newMessage}
          onChange={e => setNewMessage(e.target.value)}
        />
        <div className='message-actions'>
          <button className='send-button' onClick={handleSendMessage}>
            Send
          </button>
          {error && <span className='error-message'>{error}</span>}
        </div>
      </div>
    </div>
  );
};

export default GameChatPage;
